// Match commentary generator

const GOAL_COMMENTARY = [
  (p, t) => `${p.name} finds the back of the net! What a strike for ${t}!`,
  (p, t) => `GOOOAL! ${p.name} smashes it in! The crowd goes wild!`,
  (p, t) => `A brilliant finish from ${p.name}! ${t} take the lead!`,
  (p, t) => `${p.name} with a clinical strike from inside the box!`,
  (p, t) => `A thunderous shot from ${p.name}! The keeper had no chance!`,
  (p, t) => `${p.name} slots it home with composure! Great goal!`,
  (p, t) => `What a moment for ${p.name}! A beautiful curling effort!`,
  (p, t) => `${p.name} pounces on the loose ball and fires it in!`,
  (p, t) => `A tap-in for ${p.name}, but they all count! ${t} celebrate!`,
  (p, t) => `${p.name} rises highest and heads it into the corner! Magnificent!`,
  (p, t) => `A screamer from 25 yards! ${p.name} absolutely rifles it in!`,
  (p, t) => `Cool as you like! ${p.name} chips the keeper for a brilliant goal!`,
];

const ASSIST_COMMENTARY = [
  (p) => `Superb pass from ${p.name} to set up the goal.`,
  (p) => `${p.name} with the perfect through ball.`,
  (p) => `A delightful cross from ${p.name} finds the scorer.`,
  (p) => `${p.name} picks out the run with a precise delivery.`,
  (p) => `Vision from ${p.name}! What a ball to create that chance.`,
  (p) => `${p.name} threads the needle with a brilliant assist.`,
];

const SAVE_COMMENTARY = [
  (p, t) => `${p.name} unleashes a powerful shot, but the keeper makes a stunning save!`,
  (p, t) => `Great strike from ${p.name}, but it's tipped over the bar!`,
  (p, t) => `${p.name} gets in behind the defense and shoots... saved brilliantly!`,
  (p, t) => `A diving header from ${p.name}! The goalkeeper denies them!`,
  (p, t) => `${p.name} cuts inside and fires, but the keeper is equal to it!`,
  (p, t) => `Incredible reflexes from the keeper to keep out ${p.name}'s effort!`,
  (p, t) => `${p.name} strikes from the edge of the area... just wide!`,
  (p, t) => `A chance for ${p.name}! The shot is blocked on the line!`,
];

const YELLOW_CARD_COMMENTARY = [
  (p, t) => `${p.name} goes into the book for a reckless challenge. The referee shows yellow.`,
  (p, t) => `A late tackle from ${p.name}. That's a yellow card, no arguments there.`,
  (p, t) => `${p.name} catches the opponent's ankles. Booked for the foul.`,
  (p, t) => `The referee reaches for his pocket... yellow card for ${p.name}.`,
  (p, t) => `${p.name} brings down the attacker. A cynical foul earns a booking.`,
  (p, t) => `Dissent from ${p.name}! The referee won't tolerate that. Yellow card shown.`,
];

const RED_CARD_COMMENTARY = [
  (p, t) => `${p.name} is sent off! A terrible tackle leaves the referee no choice! Straight red!`,
  (p, t) => `RED CARD! ${p.name} is dismissed for a dangerous challenge! ${t} down to 10 men!`,
  (p, t) => `${p.name} sees red! That's a career-ending type of tackle!`,
  (p, t) => `The referee shows red to ${p.name}! A moment of madness!`,
];

const INJURY_COMMENTARY = [
  (p, t, weeks) => `${p.name} goes down holding their leg! The physio rushes on. They'll be out for ${weeks} week${weeks > 1 ? 's' : ''}.`,
  (p, t, weeks) => `Bad news for ${t} - ${p.name} has to be stretchered off. Expected to miss ${weeks} match${weeks > 1 ? 'es' : ''}.`,
  (p, t, weeks) => `${p.name} pulls up with what looks like a muscle injury. They won't be available for ${weeks} week${weeks > 1 ? 's' : ''}.`,
];

const HALFTIME_COMMENTARY = [
  (h, a, hs, as) => `The referee blows for half time. ${h} ${hs} - ${as} ${a}. ${hs > as ? h + ' in control.' : hs < as ? a + ' with the advantage.' : 'All square at the break.'}`,
];

const FULLTIME_COMMENTARY = [
  (h, a, hs, as) => `Full time! ${h} ${hs} - ${as} ${a}. ${hs > as ? 'A deserved win for ' + h + '!' : hs < as ? a + ' take all three points!' : 'Honours even in an entertaining draw!'}`,
];

const KICKOFF_COMMENTARY = [
  (h, a) => `The referee blows the whistle and we are underway! ${h} vs ${a}!`,
  (h, a) => `Kickoff! The atmosphere is electric as ${h} face ${a}!`,
];

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export const generateCommentary = (event, homeTeam, awayTeam) => {
  switch (event.type) {
    case 'goal': {
      const goalText = pick(GOAL_COMMENTARY)(event.player, event.teamName);
      const assistText = event.assister ? ' ' + pick(ASSIST_COMMENTARY)(event.assister) : '';
      return goalText + assistText;
    }
    case 'save':
      return pick(SAVE_COMMENTARY)(event.player, event.teamName);
    case 'yellow_card':
      return pick(YELLOW_CARD_COMMENTARY)(event.player, event.teamName);
    case 'red_card':
      return pick(RED_CARD_COMMENTARY)(event.player, event.teamName);
    case 'injury':
      return pick(INJURY_COMMENTARY)(event.player, event.teamName, event.injuryWeeks);
    case 'halftime':
      return pick(HALFTIME_COMMENTARY)(homeTeam?.name, awayTeam?.name, event.homeScore, event.awayScore);
    case 'fulltime':
      return pick(FULLTIME_COMMENTARY)(homeTeam?.name, awayTeam?.name, event.homeScore, event.awayScore);
    case 'kickoff':
      return pick(KICKOFF_COMMENTARY)(homeTeam?.name, awayTeam?.name);
    case 'substitution':
      return `Tactical change! ${event.playerOut?.name} makes way for ${event.playerIn?.name}.`;
    default:
      return event.message || '';
  }
};
